import React from "react";

const SalaryComponentsTable = ({
  components,
  search,
  typeFilter,
  statusFilter,
  onEdit,
   onDelete,
}) => {

  const filteredComponents = components.filter((component) => {

    const matchesSearch = component.componentName
      .toLowerCase()
      .includes(search.toLowerCase());

    const matchesType =
      typeFilter === "All" ||
      component.type === typeFilter;

    const matchesStatus =
      statusFilter === "All" ||
      component.status === statusFilter;

    return (
      matchesSearch &&
      matchesType &&
      matchesStatus
    );

  });

  return (
    <div className="finance-table-card">

      <table className="finance-table">

        <thead>

          <tr>

            <th>S.No</th>
            <th>Component Name</th>
            <th>Type</th>
            <th>Calculation Type</th>
            <th>Amount</th>
            <th>Taxable</th>
            <th>Status</th>
            <th>Actions</th>

          </tr>

        </thead>

        <tbody>

          {filteredComponents.length > 0 ? (

            filteredComponents.map((component, index) => (

              <tr key={component.id}>

                <td>{index + 1}</td>

                <td>{component.componentName}</td>

                <td>{component.type}</td>

                <td>{component.calculationType}</td>

                <td>
                  ₹ {Number(component.amount).toLocaleString()}
                </td>

                <td>
                  {component.taxable ? "Yes" : "No"}
                </td>

                <td>

                  <span
                    className={
                      component.status === "Active"
                        ? "status-active"
                        : "status-inactive"
                    }
                  >
                    {component.status}
                  </span>

                </td>

                <td>

                  <button
                    className="action-btn edit-btn"
                    onClick={() => onEdit(component)}
                  >
                    Edit
                  </button>

                  <button
  className="action-btn delete-btn"
  onClick={() => onDelete(component.id)}
>
  Delete
</button>

                </td>

              </tr>

            ))

          ) : (

            <tr>

              <td
                colSpan="8"
                style={{
                  textAlign: "center",
                  padding: "30px",
                  color: "#6b7280",
                }}
              >
                No salary components found.
              </td>

            </tr>

          )}

        </tbody>

      </table>

    </div>
  );
};

export default SalaryComponentsTable;